import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_aa275e5c from 'nuxt_plugin_bootstrapvue_aa275e5c' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_templatesplugin83649780_f8093ff8 from 'nuxt_plugin_templatesplugin83649780_f8093ff8' // Source: ./templates.plugin.83649780.js (mode: 'all')
import nuxt_plugin_toast_63861252 from 'nuxt_plugin_toast_63861252' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_d15474ba from 'nuxt_plugin_axios_d15474ba' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginrouting_4e71f243 from 'nuxt_plugin_pluginrouting_4e71f243' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_3006d80c from 'nuxt_plugin_pluginmain_3006d80c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_veevalidate_cc931970 from 'nuxt_plugin_veevalidate_cc931970' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_moment_620e8055 from 'nuxt_plugin_moment_620e8055' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_googleanalytics_409e82ba from 'nuxt_plugin_googleanalytics_409e82ba' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_ckeditor5_3ae1baa3 from 'nuxt_plugin_ckeditor5_3ae1baa3' // Source: ../plugins/ckeditor5.ts (mode: 'client')
import nuxt_plugin_veevalidate_1a0c172c from 'nuxt_plugin_veevalidate_1a0c172c' // Source: ../plugins/vee-validate.ts (mode: 'client')
import nuxt_plugin_vueobservevisibilityclient_42d89bd8 from 'nuxt_plugin_vueobservevisibilityclient_42d89bd8' // Source: ../plugins/vue-observe-visibility.client.ts (mode: 'client')
import nuxt_plugin_plugin_cbe666c2 from 'nuxt_plugin_plugin_cbe666c2' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | my.cvents.eu","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","href":"https:\u002F\u002Fwww.cvents.eu\u002Fskin\u002Ffrontend\u002Fboilerplate\u002Fcvents\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Poppins&display=swap"}],"script":[{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fjquery\u002F3.1.0\u002Fjquery.min.js"},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fsemantic-ui\u002F2.2.7\u002Fsemantic.min.js"},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_aa275e5c === 'function') {
    await nuxt_plugin_bootstrapvue_aa275e5c(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin83649780_f8093ff8 === 'function') {
    await nuxt_plugin_templatesplugin83649780_f8093ff8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_63861252 === 'function') {
    await nuxt_plugin_toast_63861252(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_d15474ba === 'function') {
    await nuxt_plugin_axios_d15474ba(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_4e71f243 === 'function') {
    await nuxt_plugin_pluginrouting_4e71f243(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_3006d80c === 'function') {
    await nuxt_plugin_pluginmain_3006d80c(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_cc931970 === 'function') {
    await nuxt_plugin_veevalidate_cc931970(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_620e8055 === 'function') {
    await nuxt_plugin_moment_620e8055(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_409e82ba === 'function') {
    await nuxt_plugin_googleanalytics_409e82ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ckeditor5_3ae1baa3 === 'function') {
    await nuxt_plugin_ckeditor5_3ae1baa3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_1a0c172c === 'function') {
    await nuxt_plugin_veevalidate_1a0c172c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibilityclient_42d89bd8 === 'function') {
    await nuxt_plugin_vueobservevisibilityclient_42d89bd8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_cbe666c2 === 'function') {
    await nuxt_plugin_plugin_cbe666c2(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
